// extracted by mini-css-extract-plugin
export default {"container":"Stepper_container__6WjFf","wrapper":"Stepper_wrapper__Zvm7Y","logo":"Stepper_logo__EtqY-","body":"Stepper_body__7IjHS"};